// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
  }
  
  .signup-header {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .signup-header h2 {
    font-size: 1.8rem;
    color: #1e293b;
    margin: 10px 0 5px;
  }
  
  .signup-header p {
    color: #475569;
    font-size: 1.1rem;
  }
  
  .signup-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    padding: 30px;
    max-width: 500px;
    margin: 0 auto;
    width: 100%;
  }
  
  .error-message {
    background: #fee2e2;
    color: #b91c1c;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 0.9rem;
  }
  
  .signup-form .form-group {
    margin-bottom: 20px;
  }
  
  .signup-form label {
    display: block;
    font-weight: 500;
    color: #334155;
    margin-bottom: 6px;
  }
  
  .signup-form input {
    width: 100%;
    padding: 14px 16px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    font-size: 1rem;
    transition: all 0.3s;
  }
  
  .signup-form input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }
  
  .terms-container {
    display: flex;
    align-items: flex-start;
    margin: 20px 0;
  }
  
  .terms-container input {
    margin-top: 3px;
  }
  
  .terms-container label {
    margin-left: 10px;
    color: #475569;
    font-size: 0.95rem;
  }
  
  .terms-container a {
    color: #3b82f6;
    text-decoration: none;
  }
  
  .terms-container a:hover {
    text-decoration: underline;
  }
  
  .submit-btn {
    width: 100%;
    background: linear-gradient(to right, #2563eb, #1d4ed8);
    color: white;
    border: none;
    padding: 16px;
    border-radius: 10px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
  }
  
  .submit-btn:hover {
    background: linear-gradient(to right, #1d4ed8, #1e40af);
  }
  
  .divider {
    position: relative;
    margin: 25px 0;
  }
  
  .divider::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #e2e8f0;
    transform: translateY(-50%);
  }
  
  .divider span {
    position: relative;
    padding: 0 10px;
    background: white;
    color: #64748b;
    font-size: 0.9rem;
  }
  
  .login-link {
    text-align: center;
  }
  
  .login-link a {
    color: #3b82f6;
    font-weight: 500;
    font-size: 1.05rem;
    text-decoration: none;
  }
  
  .login-link a:hover {
    text-decoration: underline;
  }
  
  .signup-footer {
    text-align: center;
    color: #64748b;
    margin-top: 20px;
    font-size: 0.9rem;
  }


  `, "",{"version":3,"sources":["webpack://./src/pages/SignupPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,uDAAuD;IACvD,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,uDAAuD;EACzD;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB","sourcesContent":[".signup-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 20px;\n  }\n  \n  .signup-header {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  \n  .signup-header h2 {\n    font-size: 1.8rem;\n    color: #1e293b;\n    margin: 10px 0 5px;\n  }\n  \n  .signup-header p {\n    color: #475569;\n    font-size: 1.1rem;\n  }\n  \n  .signup-card {\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    padding: 30px;\n    max-width: 500px;\n    margin: 0 auto;\n    width: 100%;\n  }\n  \n  .error-message {\n    background: #fee2e2;\n    color: #b91c1c;\n    padding: 12px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    font-size: 0.9rem;\n  }\n  \n  .signup-form .form-group {\n    margin-bottom: 20px;\n  }\n  \n  .signup-form label {\n    display: block;\n    font-weight: 500;\n    color: #334155;\n    margin-bottom: 6px;\n  }\n  \n  .signup-form input {\n    width: 100%;\n    padding: 14px 16px;\n    border: 1px solid #cbd5e1;\n    border-radius: 10px;\n    font-size: 1rem;\n    transition: all 0.3s;\n  }\n  \n  .signup-form input:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n  }\n  \n  .terms-container {\n    display: flex;\n    align-items: flex-start;\n    margin: 20px 0;\n  }\n  \n  .terms-container input {\n    margin-top: 3px;\n  }\n  \n  .terms-container label {\n    margin-left: 10px;\n    color: #475569;\n    font-size: 0.95rem;\n  }\n  \n  .terms-container a {\n    color: #3b82f6;\n    text-decoration: none;\n  }\n  \n  .terms-container a:hover {\n    text-decoration: underline;\n  }\n  \n  .submit-btn {\n    width: 100%;\n    background: linear-gradient(to right, #2563eb, #1d4ed8);\n    color: white;\n    border: none;\n    padding: 16px;\n    border-radius: 10px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s;\n  }\n  \n  .submit-btn:hover {\n    background: linear-gradient(to right, #1d4ed8, #1e40af);\n  }\n  \n  .divider {\n    position: relative;\n    margin: 25px 0;\n  }\n  \n  .divider::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background: #e2e8f0;\n    transform: translateY(-50%);\n  }\n  \n  .divider span {\n    position: relative;\n    padding: 0 10px;\n    background: white;\n    color: #64748b;\n    font-size: 0.9rem;\n  }\n  \n  .login-link {\n    text-align: center;\n  }\n  \n  .login-link a {\n    color: #3b82f6;\n    font-weight: 500;\n    font-size: 1.05rem;\n    text-decoration: none;\n  }\n  \n  .login-link a:hover {\n    text-decoration: underline;\n  }\n  \n  .signup-footer {\n    text-align: center;\n    color: #64748b;\n    margin-top: 20px;\n    font-size: 0.9rem;\n  }\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
